import { Stack, TextField } from "@mui/material";
import type { PaymentTermsPeriod } from "adl-gen/ferovinum/app/db";
import { ExpandableRadio } from "components/widgets/inputs/expandable-radio/expandable-radio";
import type { FormikProps } from "formik";
import { useCallback } from "react";
import type { SetupNewAllocationFormValues } from "../new-purchaser-allocation-page-view";
import { CardWithTitle } from "./card-with-title";

export const PaymentTermsCard = ({
  form,
}: {
  form: FormikProps<SetupNewAllocationFormValues>;
}) => {
  const handlePaymentTermsChange = useCallback(
    (kind: PaymentTermsPeriod["kind"], value: number) => {
      form.setFieldValue("paymentTerms", { kind, value });
    },
    [form],
  );

  const currentType = form.values.paymentTerms?.kind || "daysAfterCollection";
  const currentValue = form.values.paymentTerms?.value || "";

  return (
    <CardWithTitle
      title="Payment Terms"
      subtitle="Please specify the date on which payment is expected, as agreed with your purchaser(s)."
      body={
        <Stack spacing={2}>
          <ExpandableRadio
            options={[
              {
                value: "daysAfterCollection",
                label: "Number of days after delivery or collection",
                children: (
                  <TextField
                    label="Number of Days"
                    name="daysAfterCollection"
                    required={currentType === "daysAfterCollection"}
                    type="number"
                    value={
                      currentType === "daysAfterCollection" ? currentValue : ""
                    }
                    onChange={(e) =>
                      handlePaymentTermsChange(
                        "daysAfterCollection",
                        Number.parseInt(e.target.value, 10),
                      )
                    }
                  />
                ),
              },
              {
                value: "endOfMonth",
                label:
                  "At the end of a number of months following delivery or collection",
                children: (
                  <TextField
                    label="Number of Months"
                    name="endOfMonth"
                    required={currentType === "endOfMonth"}
                    type="number"
                    value={currentType === "endOfMonth" ? currentValue : ""}
                    onChange={(e) =>
                      handlePaymentTermsChange(
                        "endOfMonth",
                        Number.parseInt(e.target.value, 10),
                      )
                    }
                  />
                ),
              },
            ]}
            value={currentType}
            onChange={(type: PaymentTermsPeriod["kind"]) => {
              handlePaymentTermsChange(type, 0);
            }}
          />
        </Stack>
      }
    />
  );
};
